export class Produtosformulario {
  produtosLista: Array<Produtoformulario>; 
}

export class Produtoformulario {
  codigoProduto: string;
  descontoProduto: string;
}
